import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterData from './phonics/phonics_data_cc';

/**
 * Phonics Letter Cc 页面
 * 复用 PhonicsAtoZ 通用组件，只传入 Cc 数据
 */
function PhonicsCc() {
  return <PhonicsAtoZ letterData={letterData} />;
}

export default PhonicsCc;
